import CollectionForm from './CollectionForm';

export default CollectionForm;
